export const routes = {
  about: "/about",
  contactUs: "/contact",
  innovation: "/info",
  home: "/", // This is the default route
};
